var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full text-gray-600 leading-relaxed uppercase"},[_c('div',{staticClass:"text-right cursor-pointer mt-6 lg:mt-0",on:{"click":function($event){return _vm.mail()}}},[_vm._v("info at acs47 dot de")])])}
var staticRenderFns = []

export { render, staticRenderFns }